/**
 * Remontée automatique des erreurs de l'interface vers le serveur (puis Linear).
 * Les doublons d'une même session sont filtrés ici ; le serveur regroupe ensuite les erreurs
 * identiques en un seul ticket.
 */
const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api/bug-reports/client`;
const MAX_PER_PAGE = 10;
const sent = new Set();
let count = 0;

function appVersion() {
  const s = [...document.scripts].map((x) => x.src).find((src) => /\/static\/js\/main\.[\w]+\.js/.test(src));
  return s ? s.split("/").pop() : "dev";
}

export function reportError({ kind = "erreur", message, stack, componentStack }) {
  try {
    const msg = String(message || "Erreur inconnue").slice(0, 2000);
    const key = `${kind}|${msg}`;
    if (sent.has(key) || count >= MAX_PER_PAGE) return;
    sent.add(key);
    count += 1;
    const headers = { "Content-Type": "application/json" };
    let token = null;
    try { token = localStorage.getItem("session_token"); } catch { /* stockage indisponible */ }
    if (token) headers.Authorization = `Bearer ${token}`;
    fetch(API, {
      method: "POST",
      headers,
      keepalive: true,
      body: JSON.stringify({
        kind,
        message: msg,
        stack: stack ? String(stack).slice(0, 8000) : null,
        component_stack: componentStack ? String(componentStack).slice(0, 4000) : null,
        url: window.location.href.slice(0, 500),
        app_version: appVersion(),
      }),
    }).catch(() => { /* la remontée ne doit jamais gêner l'utilisateur */ });
  } catch { /* idem */ }
}

export function installErrorReporter() {
  if (process.env.NODE_ENV !== "production") return;
  window.addEventListener("error", (e) => {
    if (!e.error && !e.message) return; // erreur de chargement de ressource (image, script)
    reportError({ kind: "erreur JS", message: e.message || String(e.error), stack: e.error?.stack });
  });
  window.addEventListener("unhandledrejection", (e) => {
    const r = e.reason;
    reportError({ kind: "promesse rejetée", message: r?.message || String(r), stack: r?.stack });
  });
}
